export default __webpack_public_path__ + "static/media/edit.0026afb7.svg";